<template>
	<div class="main">
        <img src="../assets/img/404.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.main {
		background-color: #fff;
		min-height: 100vh;
		img {
			width: 100%;
			margin-top: 30%;
		}
	}
</style>
